"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JsonSourceProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _DumbappValueFunction = require("../DumbappValueFunction");
var _sourceUtil = require("../source-util");
class JsonSourceProvider {
  constructor() {
    (0, _defineProperty2.default)(this, "name", "json");
  }
  getValue(provider, source) {
    let data = new _DumbappValueFunction.DataStringFunctions();
    for (let it of source.json) {
      let literal = (0, _sourceUtil.getLiteralSourceParameters)(it);
      if (literal) {
        data[it.name] = {
          value() {
            return literal.value;
          }
        };
      } else {
        data[it.name] = {
          async value() {
            let res = await provider.getSourceValue(it.value, it);
            let resolved = await res.value();
            if ((0, _DumbappValueFunction.isDataStringFunctions)(resolved)) {
              throw new Error("Json Source element can't resolve to more JSON: " + resolved);
            }
            return resolved;
          }
        };
      }
    }
    return {
      value() {
        return data;
      }
    };
  }
}
exports.JsonSourceProvider = JsonSourceProvider;
//# sourceMappingURL=JsonSourceProvider.js.map